import React, { useState, useEffect } from "react";
import Spinner from 'react-bootstrap/Spinner';
import "../css/NotFound.css";

function NotFound({ parentLoading, Error }) {
  const [loading, setLoading] = useState(true);

  if (loading || parentLoading) {
    return (
      <div className="divfill">
        <div style={{ textAlign: "center", marginTop: "50px" }}>
          <Spinner animation="border" variant="dark" />
        </div>
      </div>
    );
  }
}

export default NotFound;
